class CollectionShowcase extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.track = this.querySelector('[data-showcase-track]');
    this.prevButton = this.querySelector('[data-showcase-prev]');
    this.nextButton = this.querySelector('[data-showcase-next]');
    this.slides = Array.from(this.querySelectorAll('.product-collection-showcase__slide'));

    this.prevButton?.addEventListener('click', () => this.scrollBySlide(-1));
    this.nextButton?.addEventListener('click', () => this.scrollBySlide(1));
    this.track?.addEventListener('scroll', () => this.syncControls(), { passive: true });

    this.syncControls();

    if (typeof ResizeObserver === 'function') {
      this.resizeObserver = new ResizeObserver(() => this.syncControls());
      this.resizeObserver.observe(this);
    }
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  slideWidth() {
    const slide = this.slides[0];
    if (!slide || !this.track) return this.track?.clientWidth || 0;
    const styles = window.getComputedStyle(this.track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  currentIndex() {
    if (!this.track) return 0;
    const width = this.slideWidth();
    if (!width) return 0;
    return Math.round(this.track.scrollLeft / width);
  }

  scrollBySlide(direction) {
    if (!this.track) return;
    this.track.scrollBy({ left: direction * this.slideWidth(), behavior: 'smooth' });
  }

  syncControls() {
    const index = this.currentIndex();
    const maxIndex = Math.max(this.slides.length - 1, 0);

    if (this.prevButton) this.prevButton.disabled = index <= 0;
    if (this.nextButton) this.nextButton.disabled = index >= maxIndex;
  }
}

if (!customElements.get('collection-showcase')) {
  customElements.define('collection-showcase', CollectionShowcase);
}
